<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;"
					src="../../../assets/img/usericon.png" />企业用户中心
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form style="text-align: right;">
					<el-form-item>
            <!-- <el-button v-no-more-click  class="addBtn" style="left: 1115px;" v-if="dataForm.status == 2" type="info"
							@click="editHandle()">{{isEditBtn ? '修改' : '提交'}}</el-button> -->
						<el-button v-no-more-click  class="addBtn" style="left: 1000px;" v-if="dataForm.status == 0" type="primary"
							@click="dataFormSubmitHandle(0)">保存</el-button>
						<el-button v-no-more-click  class="addBtn" style="left: 1115px;" v-if="dataForm.status == 0" type="info"
							@click="dataFormSubmitHandle(1)">提交</el-button>
						<el-button class="addBtn" style="left: 1515px;" type="info" @click="getInfo()">刷新</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>


		<el-form label-width="120px" style="border-bottom: 1px solid #D7D7D7;padding-top: 20px;" :model="dataForm"
			:rules="dataRule" ref="dataForm">
			<el-row>
				<el-col :sm="24" :lg="8">
					<el-row>
						<div
								style="font-size: 12px;font-weight: bold;color: #343434;line-height: 48px;width: 120px;text-align: right;">
							企业营业执照照片</div>
						<div>
							<el-form-item prop="licensePath" style="display: inline-block;">
								<el-upload ref="upload" :action="url"  class="avatar-uploader" :multiple="multiple"
										   :before-upload="beforeUploadHandle" :on-success="licensePathsuccessHandle"
										   :auto-upload="true" :show-file-list="false"
										   :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false">
									<img v-if="dataForm.licensePath"
										 :src="dataForm.licensePath" class="avatar">
									<i v-else
									   :style="{backgroundImage:'url('+require('../../../assets/img/yingye.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}"
									   :class="dataForm.status > 0 ? 'el-icon-circle-plus avatar-uploader-icon el-noicon' : 'el-icon-circle-plus avatar-uploader-icon'"></i>
									<div slot="tip" class="el-upload__tip" style="line-height: 20px;cursor: pointer;">
										{{tip}}
                    <span class="delUploadPic el-icon-view" v-if="dataForm.licensePath" @click="handlePictureCardPreview(dataForm.licensePath)" style="color:#188eee;margin-left:10px;"></span>
                    <span class="delUploadPic el-icon-delete" v-if="dataForm.licensePath && (dataForm.status > 0?false:true)" @click="delPicUrl('licensePath')"></span>
                  </div>
								</el-upload>
							</el-form-item>
						</div>
					</el-row>
				</el-col>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
				<el-col :sm="24" :lg="16">
					<el-row>
						<div
								style="font-size: 12px;font-weight: bold;color: #343434;line-height: 48px;width: 120px;text-align: right;">
							法人身份证<font color='red'>(非必填)</font>
						</div>
						<div>
							<el-form-item prop="idcardFacePath" style="display: inline-block;">
								<el-upload ref="upload" :action="url" class="avatar-uploader"
										   :multiple="multiple" :before-upload="beforeUploadHandle"
										   :on-success="beforesuccessHandle" :auto-upload="true"
										   :show-file-list="false" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false">
									<img
										 v-if="dataForm.idcardFacePath" :src="dataForm.idcardFacePath"
										 class="avatar">
									<i v-else
									   :style="{backgroundImage:'url('+require('../../../assets/img/cardFront.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}"
									   :class="dataForm.status > 0 ? 'el-icon-circle-plus avatar-uploader-icon el-noicon' : 'el-icon-circle-plus avatar-uploader-icon'"></i>
									<div slot="tip" class="el-upload__tip" style="line-height: 20px;">
										{{tip1}}
                    <span class="delUploadPic el-icon-view" v-if="dataForm.idcardFacePath" @click="handlePictureCardPreview(dataForm.idcardFacePath)" style="color:#188eee;margin-left:10px;"></span>
                    <span class="delUploadPic el-icon-delete" v-if="dataForm.idcardFacePath && (dataForm.status > 0?false:true)" @click="delPicUrl('idcardFacePath')"></span>
                  </div>
								</el-upload>
							</el-form-item>
							<el-form-item prop="idcardBackPath" style="display: inline-block;">
								<el-upload ref="upload" :action="url" class="avatar-uploader"
										   :multiple="multiple" :before-upload="beforeUploadHandle"
										   :on-success="backsuccessHandle" :auto-upload="true" :show-file-list="false"
										   :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false">
									<img v-if="dataForm.idcardBackPath"
										 :src="dataForm.idcardBackPath" class="avatar">
									<i v-else
									   :style="{backgroundImage:'url('+require('../../../assets/img/cardBack.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}"
									   :class="dataForm.status > 0 ? 'el-icon-circle-plus avatar-uploader-icon el-noicon' : 'el-icon-circle-plus avatar-uploader-icon'"></i>
									<div slot="tip" class="el-upload__tip" style="line-height: 20px;">
										{{tip2}}
                    <span class="delUploadPic el-icon-view" v-if="dataForm.idcardBackPath"  @click="handlePictureCardPreview(dataForm.idcardBackPath)" style="color:#188eee;margin-left:10px;"></span>
                    <span class="delUploadPic el-icon-delete" v-if="dataForm.idcardBackPath && (dataForm.status > 0?false:true)" @click="delPicUrl('idcardBackPath')"></span>
                  </div>
								</el-upload>
							</el-form-item>
						</div>
					</el-row>

				</el-col>
			</el-row>
			<el-row>
				<el-col :sm="12" :lg="12">
					<el-form-item label="经营范围" prop="businessScope">
						<el-input v-model="dataForm.businessScope" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" rows="6"
								  maxlength="500" show-word-limit type="textarea" placeholder="经营范围"
								  style="border: none;width: 91%;"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="12">
					<el-form-item label="企业简介" prop="intro">
						<el-input v-model="dataForm.intro" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" rows="6"
							maxlength="500" show-word-limit type="textarea" placeholder="企业简介"
							style="border: none;width: 91%;"></el-input>
					</el-form-item>
				</el-col>

			</el-row>
			<el-row>
				<el-col :sm="12" :lg="6">
					<el-form-item label="企业名称" prop="caName">
						<el-input style="width: 80%;" :disabled="(dataForm.status != 0 && dataForm.caName) ? true : false"
							v-model="dataForm.caName" placeholder="企业名称"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="社会信用代码" prop="taxCode">
						<el-input style="width: 80%;" :disabled="(dataForm.status != 0 && dataForm.caName) ? true : false"
							v-model="dataForm.taxCode" placeholder="社会信用代码"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="开户行名称" prop="bankName">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.bankName" placeholder="开户行"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="开户账号" prop="bankAccount">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.bankAccount" placeholder="开户账号"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :sm="12" :lg="6">
					<el-form-item label="银行行号信息" prop="bankCode">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.bankCode" placeholder="银行行号信息"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="注册地址" prop="address">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.address" placeholder="注册地址"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="注册电话" prop="phone">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.phone" placeholder="注册电话"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="法人姓名" prop="legalPersonName">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.legalPersonName" placeholder="法人姓名"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>

				<el-col :sm="12" :lg="6">
					<el-form-item label="法人身份证号" prop="legalPersonIdcard">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.legalPersonIdcard" placeholder="法人身份证号"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="法人手机号" prop="legalPersonPhone">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.legalPersonPhone" placeholder="法人手机号"></el-input>
					</el-form-item>
				</el-col>

      <!-- 新增字段 -->
        <el-col :sm="12" :lg="6">
					<el-form-item label="成立时间" prop="esstablishmentTime">
            <el-date-picker type="date" placeholder="选择日期" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" v-model="dataForm.esstablishmentTime" style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
				</el-col>
        <el-col :sm="12" :lg="6">
					<el-form-item label="经营状况" prop="operatingConditions">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.operatingConditions" placeholder="经营状况"></el-input>
					</el-form-item>
				</el-col>
			</el-row>

      <el-row>
        <el-col :sm="12" :lg="6">
					<el-form-item label="所属行业" prop="industry">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.industry" placeholder="所属行业"></el-input>
					</el-form-item>
				</el-col>
        <el-col :sm="12" :lg="6">
					<el-form-item label="开票地址" prop="taxAddress">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.taxAddress" placeholder="开票地址"></el-input>
					</el-form-item>
				</el-col>
        <el-col :sm="12" :lg="6">
					<el-form-item label="是否属于禁入或敏感行业" prop="isSensitive" label-width="200px">
						<!-- <el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.isSensitive" placeholder="是否属于禁入或敏感行业"></el-input> -->
              <el-checkbox v-model="dataForm.isSensitive" :disabled="true"></el-checkbox>
					</el-form-item>
				</el-col>
         <el-col :sm="12" :lg="6" v-if="isPayChannel == 'OPERATE'">
					<el-form-item label="支付渠道" prop="payChannel">
              <el-select v-model="dataForm.payChannel" placeholder="请选择" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false">
                <el-option
                  v-for="item in payChannel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
					</el-form-item>
				</el-col>
      </el-row>

      <el-row>
        <el-col :sm="12" :lg="12">
					<el-form-item label="用工场景描述" prop="employmentScenario">
						<el-input type="textarea" style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.employmentScenario" placeholder="用工场景描述"></el-input>
					</el-form-item>
				</el-col>
      </el-row>

		</el-form>
		<div v-if="dataForm.processList.length > 0">
			<h4 style="margin-left: 30px;font-weight: bold;padding-top:20px;">用户信息状态</h4>
			<p v-for="item in dataForm.processList" style="margin: 0;line-height: 36px;"><span
					style="width: 8px;height: 8px;border-radius: 4px;background-color: #5389DF;display: inline-block;margin-left: 30px;margin-right: 10px;">
				</span>{{item.createDate}}&nbsp;&nbsp;&nbsp;{{item.action}}</p>
		</div>
	</el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import ossUploadImg from '../oss/oss-upload-img'
import Cookies from 'js-cookie'

export default {
  components: {
    ossUploadImg
  },
  data () {
    return {
      isEditBtn:true,//已审核增加修改功能
      isPayChannel:`${Cookies.get('admin_role')}`,
      payChannel:[
        {value:0,label:'招商银行'},
        {value:1,label:'支付宝'},
        {value:2,label:'平安银行'},
        {value:3,label:'招商银行灵账'},
      ],
      multiple: false,
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      tip: '统一社会信用编码证书',
      tip1: '身份证正面照',
      tip2: '身份证反面照',
      visible: true,
      dialogImageUrl:'',
      dialogVisible:false,
      dataForm: {
        intro: '',
        businessScope: '',
        id: '',
        caName: '',
        taxCode: '',
        bankName: '',
        bankAccount: '',
        address: '',
        contacts: '',
        bankCode: '',
        phone: '',
        licensePath: '',
        idcardFacePath: '',
        idcardBackPath: '',
        legalPersonIdcard: '',
        legalPersonName: '',
        legalPersonPhone: '',
        isEnable: 1,
        status: '',
        userId: '',
        userStatus: '',
        processList: []
      }
    }
  },
  computed: {
    dataRule () {
		var validateName = (rule, value, callback) => {
            if(!value){
                callback('必填项不能为空')
            }
            //  else if(value.indexOf('（') > -1 || value.indexOf('）') > -1 ){
            //     callback(new Error("检测出符号错误'（'与'）'必须是英文符号格式！"))
            // }
            callback()
        }
      var checkNumtwo = (rule, value, callback) => {
        if (/^[A-Za-z0-9]{7,20}$/.test(value)) {
          callback()
        } else {
          callback(new Error('社会信用代码格式错误'))
        }
      }
      var checknum = (rule, value, callback) => {
        if (!isNumber(value)) {
          callback(new Error('请输入数字值'))
        }
        callback()
      }
      var checkfloat = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入数字值,并且最多两位小数'))
        }
      }
      var checkphone = (rule, value, callback) => {
        if (/^1\d{10}$/.test(value)) {
          callback()
        } else if (/^0\d{2,3}-?\d{7,8}$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入手机号'))
        }
      }
      var checkcard = (rule, value, callback) => {
        if (/^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/
          .test(value)) {
          callback()
        } else {
          callback(new Error('请输入身份证号'))
        }
      }
      var checkbank = (rule, value, callback) => {
        // if (/^([A-Za-z0-9]{9}|[A-Za-z0-9]{12}|[A-Za-z0-9]{16}|[A-Za-z0-9]{17}|[A-Za-z0-9]{15}|[A-Za-z0-9]{19})$/.test(value)) {
          // if(/^([1-9]{1})(\d{14}|\d{18})$/.test(value)){
        if(/^\d{1,30}$/.test(value) ){
          callback()
        } else {
          callback(new Error('请输入卡号'))
        }
      }
      var checkbankCode = (rule, value, callback) => {
        if(value == ''){
          callback(new Error('请输入银行行号信息'))
        }else if(/[^\d]/.test(value)) {
          callback(new Error('只能输入数字'))
        } else {
          callback()
        }
      }
      var validateEmail = (rule, value, callback) => {
        if (!isEmail(value)) {
          return callback(new Error(this.$t('validate.format', {
            'attr': this.$t('user.email')
          })))
        }
        callback()
      }
      return {
        legalPersonIdcard: [{
          required: true,
          message: '请输入身份证号',
          validator: checkcard,
          trigger: 'blur'
        }],
        legalPersonName: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        legalPersonPhone: [{
          required: true,
          message: '输入正确的电话号码',
          validator: checkphone,
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        businessScope: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        caName: [{
			required: true,
			validator:validateName,
			trigger: 'blur'
        }],
        taxCode: [{
          required: true,
          message: '格式错误，7-20位数字或字母',
          validator: checkNumtwo,
          trigger: 'blur'
        }],
        bankName: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        bankAccount: [{
          required: true,
          message: '请输入卡号',
          trigger: 'blur'
        },{ message: '银行卡号错误，请检查位数'
        ,validator: checkbank,
        trigger: 'blur'}],
        address: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        contacts: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        bankCode: [{
          required: true,
          trigger: 'blur',
          validator:checkbankCode
        }],
        phone: [{
          required: true,
          message: '输入正确的电话号码',
          validator: checkphone,
          trigger: 'blur'
        }],
        licensePath: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }]
      }
    }
  },

  created () {
    this.getInfo()
  },
  methods: {
     // 已审核增加修改保存功能
    editHandle(){
      if(this.isEditBtn){//修改编辑功能
        this.isEditBtn = false;
      }else{//保存功能
        this.dataFormSubmitHandle(1);
      }
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file;
        this.dialogVisible = true;
      },
    // 上传之前
    beforeUploadHandle (file) {
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !==
					'image/gif') {
        this.$message.error(this.$t('upload.tip', {
          'format': 'jpg、png、gif'
        }))
        return false
      }
      if (file.size / 1024 / 1024 > 30) {
        this.$message.error('文件太大，只能上传30MB以内的文件')
        return false
      }
    },
    // 上传成功
    beforesuccessHandle (data, file) {
      this.dataForm.idcardFacePath = data.data.url
        let imgUrl = data.data.url;
        this.$http.post('/sys/plat/info/ca/idcardOCR',{imageUrl:imgUrl}).then(({ data: res })=>{
            if(res.code == 0)
			this.dataForm.legalPersonName = res.data.name;
			this.dataForm.legalPersonIdcard = res.data.idNum;
        })
    },
    backsuccessHandle (data, file) {
      this.dataForm.idcardBackPath = data.data.url
    },
    licensePathsuccessHandle (data, file) {
      this.dataForm.licensePath = data.data.url;
        let imgUrl = data.data.url;
		  const loading = this.$loading({
			lock: true,
			text: '正在识别营业执照...',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		  })
        this.$http.post('/sys/plat/info/ca/bizLicenseOcr',{imageUrl:imgUrl}).then(({ data: res })=>{
			  loading.close()
            if(res.code == 0){
			  let LicenseInfo = res.data,
                    formInfo = this.dataForm;
//                经营范围
                formInfo.businessScope = LicenseInfo.business
//			  企业名称
                formInfo.caName = LicenseInfo.name
//			  社会信用代码
                formInfo.taxCode = LicenseInfo.regNum
//			  注册地址
                formInfo.address = LicenseInfo.address
//			  法人姓名
                formInfo.legalPersonName = LicenseInfo.person
			  this.$message.success('营业执照识别成功')
		  } else {
			  this.$message.error(res.msg || '营业执照识别失败')
		  }
		  }).catch(error => {
			  loading.close()
			  console.error('营业执照识别错误:', error)
			  this.$message.error('营业执照识别失败，请重试')
		  })
    },
    getInfo () {
      this.$http.get(`/sys/user/info`).then(({
        data: res
      }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$http.get(`/sys/plat/info/ca/getInfoByUserId?userId=` + res.data.id).then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
          this.dataForm.isSensitive = this.dataForm.isSensitive == 1 ? true : false;
        }).catch(() => {})
      }).catch(() => {})
    },
    refresh () {
      this.getInfo()
    },

    yulan (url) {
      window.open(url, url)
    },
    delPicUrl(key){
      this.dataForm[key] = '';
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function (inStatus) {
        this.$refs['dataForm'].validate(valid => {
          if (!valid) {
            return false
          }
          this.dataForm.status = inStatus
          this.dataForm.isSensitive = this.dataForm.isSensitive ? 1 : 0;
          this.dataForm.saveOrSubmit = inStatus;
          this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/info/ca', this.dataForm)
            .then(({
              data: res
            }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.getInfo()
                }
              })
            })
            .catch(() => {})
        })
      },
      1000, {
        leading: true,
        trailing: false
      }
    )
  }
}
</script>
<style>
.delUploadPic{
  color: #F56C6C;
  cursor: pointer;
  float: right;
}
</style>